module.exports = __webpack_public_path__ + "img/10.1ead2575.png";